module.exports = __webpack_public_path__ + "static/img/index14.820d1a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index14.gif
// module id = zzoM
// module chunks = 0